angular.module('admin.diagrams.index', [
  'security.authorization',
  'services.utility',
  'services.adminResource',
  'services.search',
  'resources.AdminGroup',
  'resources.AdminCategory',
  'resources.AdminUser',
  'resources.Category',
  'resources.Article',
  'services.formErrors',
  'resources.User',
  'chart.js',
  'services.algoliaResource',
  'services.localizedMessages',
  'daterangepicker'
]);

angular.module('admin.diagrams.index').config(["$stateProvider", function ($stateProvider) {

  $stateProvider
    .state('admin.diagrams', {
      url: '/algolia',
      title: 'Admin / Diagrams',
      views: {
        'main@': {
          template: require('./admin-diagram.tpl.html'),
          controller: 'AdminDiagramsCtrl',
          resolve: {
            userDetails: ["$stateParams", "adminResource", function ($stateParams, adminResource) {
              //alert('dsfg');
            }],
            groups: ["AdminGroup", function (AdminGroup) {
              //alert('sdfgsdf');
            }]
          }
        }
      }
    });
}]);

angular.module('admin.diagrams.index').controller('AdminDiagramsCtrl',
  ["$scope", "$state", "adminResource", "AdminCategory", "localizedMessages", "algoliaResource", "searchService", "groups", "AdminUser", "Category", "Article", "formErrors", "growl", "userDetails", "$location", "user", function ($scope, $state, adminResource, AdminCategory, localizedMessages, algoliaResource, searchService, groups, AdminUser, Category, Article, formErrors, growl, userDetails, $location, user) {
    $scope.localizedMessages = localizedMessages;
        $scope.algoliaArticlesReindexing = function() {
            algoliaResource.indexingArticles().then((result) =>{
                $scope.algoliaSuccessArticles = true;
            }).catch((error) => {
                $scope.algoliaErrorArticles = true;
            })
        }
        $scope.algoliaAuthorReindexing = function() {
            algoliaResource.indexingAuthors().then((result) =>{
                $scope.algoliaSuccessAuthor = true;
            }).catch((error) => {
                $scope.algoliaErrorAuthor = true;
            })
        }
        $scope.algoliaTagsReindexing = function() {
            algoliaResource.indexingTags().then((result) =>{
                $scope.algoliaSuccessTags = true;
            }).catch((error) => {
                $scope.algoliaErrorTags = true;
            })
        }

  //   $scope.dataLoaded = false
  // var generateCategoryOptions = function (items, container) {
  //     angular.forEach(items, function (item, key) {
  //       if (!item.path) {
  //         return;
  //       }
  //       var depth = item.path.split('/').filter(Boolean).length;
  //       var indent = (new Array(5)).join(String.fromCharCode(160));
  //       container.push({
  //         _id: item.id,
  //         path: item.path,
  //         sefriendly: item.sefriendly,
  //         parent: item.parent,
  //         name: item.name,
  //         _name: (new Array(depth)).join(indent) + item.name
  //       });
  //       if (item.children) {
  //         generateCategoryOptions(item.children, container);
  //       }
  //     });
  //     return container;
  //   };

  //   searchService.setSearchFn(AdminUser.search);

  //   searchService.setRedirectBase('/admin/diagrams');

  //   $scope.q = '';
  //   $scope.disableInput = false;
  //   if (!user.permissions.is_editor && !user.permissions.is_admin) {
  //     $scope.q = user.account.name.full;
  //     $scope.disableInput = true;

  //     $scope.author = user.account.name.full + ' performance';
  //     $scope.author_username = user.username;
  //   }

  //   $scope.period_type = 'month';

  //   $scope.showCategory = false;

  //   $scope.categoryName = null;

  //   $scope.hasEditedName = false;

  //   $scope.categories = {};

  //   $scope.diagramData = [[]];


  //   $scope.search = searchService.search;

  //   $scope.onSelect = searchService.onSelect;

  //   $scope.changeDiagramType = changeDiagramType;

  //   $scope.getAuthor = function ($item) {
  //     $scope.author = $item.name + ' performance';
  //     $scope.author_username = $item.username;
  //   };

  //   var options = [
  //     {
  //       _id: 0,
  //       path: null,
  //       sefriendly: null,
  //       parent: null,
  //       name: 'Root',
  //       _name: 'Root'
  //     }
  //   ];
  //   Category.getPermittedTree().$promise.then(function (data) {
  //     $scope.options = generateCategoryOptions(data, options);
  //     if ($scope.options.length > 0)
  //       $scope.showCategory = true;
  //   });

  //   // AdminCategory.getTree(function (data) {
  //   //     $scope.options = generateCategoryOptions(data, options);
  //   //     if ($scope.options.length > 0)
  //   //         $scope.showCategory = true;
  //   // });

  //   $scope.rootUrl = '';
  //   $scope.data = {
  //     name: '',
  //     sefriendly: '',
  //     parent: ''
  //   };


  //   $scope.changedParent = function () {
  //     if ($scope.data.parent) {
  //       $scope.categoryName = $scope.data.parent.name;
  //     }
  //   };


  //   $scope.min_date = threeMonthsBack();
  //   $scope.max_date = getCurrentDate();

  //   //$scope.series = ['Articles'];
  //   console.log($scope.period_type)

  //   $scope.getAllArticlles = Article.getAllArticles({
  //     min_date: $scope.min_date,
  //     max_date: $scope.max_date,
  //     period_type: $scope.period_type
  //   }, fillDiagramData);


  //   $scope.diagramClick = function (points, evt) {

  //   };

  //   $scope.datePickerOptions = {
  //     locale: {
  //       applyClass: "btn-green",
  //       applyLabel: "Apply",
  //       cancelLabel: "Cancel",
  //       customRangeLabel: "Custom range",
  //       format: "YYYY-MM-DD",
  //       fromLabel: "From",
  //       toLabel: "To"
  //     },
  //     ranges: {
  //       "Last 7 Days": [
  //         $scope.min_date,
  //         $scope.max_date
  //       ],
  //       "Last 30 Days": [
  //         getLastMonthDate(),
  //         $scope.max_date
  //       ],
  //       "Last 3 Months": [
  //         threeMonthsBack(),
  //         $scope.max_date
  //       ],
  //       "Last Year": [
  //         oneYearBack(),
  //         $scope.max_date
  //       ]
  //     }
  //   };
  //   $scope.datePicker = {};
  //   $scope.datePicker.date = {startDate: $scope.min_date, endDate: $scope.max_date};


  //   $scope.makeDiagram = function () {
  //     var categories = {};
  //     angular.forEach($scope.categories.selected, function (value, key) {
  //       categories[key] = value._id;
  //     });
  //     // console.log( '>>', $scope.datePicker.date.startDate.format('YYYY-MM-DD'), convertDateFormat($scope.datePicker.date.startDate));
  //     Article.getAllArticles(
  //       {
  //         min_date: $scope.datePicker.date.startDate.format('YYYY-MM-DD'), // convertDateFormat($scope.datePicker.date.startDate),
  //         max_date: $scope.datePicker.date.endDate.format('YYYY-MM-DD'), // convertDateFormat($scope.datePicker.date.endDate),
  //         author_username: $scope.author_username,
  //         categories: categories,
  //         period_type: $scope.period_type
  //       },
  //       fillDiagramData
  //     );
  //   }

  //   function getLastWeekDate() {

  //     var date = new Date();
  //     var dateInt = date.setDate(date.getDate() - 7);
  //     var lastMontDate = new Date(dateInt);
  //     var year = lastMontDate.getFullYear();
  //     var month = lastMontDate.getMonth() + 1;
  //     if (month < 9)
  //       month = '0' + month;
  //     var day = lastMontDate.getDate();
  //     if (day < 10)
  //       day = '0' + day;
  //     return year + '-' + month + '-' + day;

  //   }

  //   function getLastMonthDate() {

  //     var date = new Date();
  //     var dateInt = date.setMonth(date.getMonth() - 1);
  //     var lastMontDate = new Date(dateInt);
  //     var year = lastMontDate.getFullYear();
  //     var month = lastMontDate.getMonth() + 1;
  //     if (month < 9)
  //       month = '0' + month;
  //     var day = lastMontDate.getDate();
  //     if (day < 10)
  //       day = '0' + day;
  //     return year + '-' + month + '-' + day;

  //   }

  //   function threeMonthsBack() {
  //     var date = new Date();
  //     date.setMonth(date.getMonth() - 3);
  //     return date.getFullYear() + '-' + (date.getMonth() + 1) + '-' + date.getDate()
  //   }

  //   function getCurrentDate() {
  //     var date = new Date();
  //     var year = date.getFullYear();
  //     var month = date.getMonth() + 1;
  //     if (month < 9)
  //       month = '0' + month;
  //     var day = date.getDate();
  //     if (day < 10)
  //       day = '0' + day;
  //     return year + '-' + month + '-' + day;

  //   }

  //   function oneYearBack() {
  //     var date = new Date();
  //     date.setFullYear(date.getFullYear() - 1);
  //     return date.getFullYear() + '-' + (date.getMonth() + 1) + '-' + date.getDate()
  //   };

  //   function convertDateFormat(inputDate) {
  //     inputDate = new Date(inputDate);
  //     var day = inputDate.getDate();
  //     var month = inputDate.getMonth();
  //     var year = inputDate.getFullYear();
  //     if (month < 9) {
  //       month = "0" + (month + 1);
  //     }
  //     if (day < 10) {
  //       day = "0" + day;
  //     }
  //     return year + "-" + month + "-" + day;
  //   }

  //   function fillDiagramData(data) {
  //     $scope.labels = [];
  //     $scope.tablearticles = [];
  //     $scope.totalarticles = 0;
  //     $scope.diagramData = [[]];
  //     angular.forEach(data.data, function (value) {
  //       $scope.totalarticles += value.count;
  //       $scope.labels.push(value.label);
  //       $scope.tablearticles.push({
  //         fecha: value.label,
  //         count: value.count
  //       });
  //       $scope.diagramData[0].push(value.count);
  //     });
  //     $scope.tablearticles.reverse();
  //     $scope.dataLoaded = true
  //   }

  //   function changeDiagramType(period_type) {
  //     $scope.dataLoaded = false

  //     $scope.period_type = period_type;
  //     $scope.diagramData[0] = [];
  //     $scope.makeDiagram()
  //   }

  }]);



// WEBPACK FOOTER //
// ./client/src/app/admin/diagrams/diagram.js